import {getCookie, hasComfortCookie, setCookie} from '../Utility/CookieUtility';
import * as $ from 'jquery';
import {injectTagManager} from '../Utility/GoogleTagManagerUtility';

export class CookieBar {

  private bodyNoScrollClass = 'body--noscroll';

  constructor() {
    this.init();
  }

  init() {
    window.addEventListener('hashchange', () => {
      this.hashChangeListener();
    });

    const currentCookie = getCookie('acceptCookies');
    if (currentCookie !== 'necessary' && currentCookie !== 'all') {
      this.showOverlay();
    } else if (currentCookie === 'all') {
      this.activateTracking();
    }

    const acceptAllButton = document.querySelector('.js-acceptAll');
    if (acceptAllButton) {
      acceptAllButton.addEventListener('click', () => {
        this.acceptCookies('all');
        this.closeOverlay();
      });
    }

    const acceptNecessaryButton = document.querySelector('.js-acceptNecessary');
    if (acceptNecessaryButton) {
      acceptNecessaryButton.addEventListener('click', () => {
        this.acceptCookies('necessary');
        this.closeOverlay();
      });
    }

    const showSettingsButton = document.querySelector('.js-showCookieSettings');
    if (showSettingsButton) {
      showSettingsButton.addEventListener('click', () => {
        this.showSettings();
      });
    }

    const acceptSelectionButton = document.querySelector('.js-acceptSelection');
    if (acceptSelectionButton) {
      acceptSelectionButton.addEventListener('click', () => {
        const statisticCookie = document.querySelector('.js-statisticCookie') as HTMLInputElement;
        if (statisticCookie && statisticCookie.checked) {
          this.acceptCookies('all');
        } else {
          this.acceptCookies('necessary');
        }
        this.closeOverlay();
      });
    }
  }

  showSettings() {
    const cookieOverlay = document.querySelector('.js-cookieOverlay');
    if (cookieOverlay) {
      cookieOverlay.classList.add('cookie--showSettings');
    }
  }

  closeOverlay() {
    document.body.classList.remove(this.bodyNoScrollClass);
    const cookieOverlay = document.querySelector('.js-cookieOverlay');
    if (cookieOverlay) {
      cookieOverlay.classList.remove('cookie--show');
    }
    location.reload();
  }

  showOverlay() {
    if (window.location.hash === '#noCookieMessage') {
      const url = location.href.replace(/#.*/, '');
      history.pushState({}, '', url);
    } else {
      document.body.classList.add(this.bodyNoScrollClass);
      const cookieOverlay = document.querySelector('.js-cookieOverlay');
      const statisticButton = document.querySelector('.js-statisticCookie') as HTMLInputElement;
      if (cookieOverlay) {
        if (statisticButton && hasComfortCookie()) {
          statisticButton.checked = true;
        }
        cookieOverlay.classList.add('cookie--show');
      }
    }
  }

  acceptCookies(status) {
    if (status === 'all') {
      this.activateTracking();
      setCookie('acceptCookies', status, 365);
    } else {
      this.deactivateTracking();
      setCookie('acceptCookies', status, 1);
    }
  }

  hashChangeListener() {
    const urlParts = document.URL.split('#');
    const anchor = (urlParts.length > 1) ? urlParts[1] : null;
    if (anchor === 'cookies') {
      this.showOverlay();
      const url = location.href.replace(/#.*/, '');
      history.pushState({}, '', url);
    }
  }

  activateTracking() {
    if ('_etracker' in window  && typeof window._etracker.enableCookies !== 'undefined') {
      window._etracker.enableCookies(document.domain);
    }
    if ($('.js-no-tagmanager').length === 0) {
      injectTagManager();
    }
  }

  deactivateTracking() {
    if ('_etracker' in window  && typeof window._etracker.disableCookies !== 'undefined') {
      window._etracker.disableCookies(document.domain);
    }
  }
}
